import { CommonModule } from '@angular/common';
import { Component, ElementRef, Injector, Type, ViewChild, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShareContentDialogComponent } from '../share-content-dialog/share-content-dialog.component';
import { toPng } from 'html-to-image';
import { ImageDownloaderService } from '@shared/service/image-downloader.service';
import { LocalRepository } from '@shared/helper/local-repository';
import { ShareReviewDialogComponent } from '../share-review-dialog/share-review-dialog.component';
import { ShareQuoteDialogComponent } from '../share-quote-dialog/share-quote-dialog.component';
import { SharePostDialogComponent } from '../share-post-dialog/share-post-dialog.component';
import { ShareBookListDialogComponent } from '../share-book-list-dialog/share-book-list-dialog.component';
import { ShareBookDialogComponent } from '../share-book-dialog/share-book-dialog.component';
import { ShareProfileDialogComponent } from '../share-profile-dialog/share-profile-dialog.component';
import { environment } from '@environments/environment';
import { BaseComponent } from '@shared/components/base/base.component';
import { SnackBarTypes } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ShareDonationDialogComponent } from '../share-donation-dialog/share-donation-dialog.component';

@Component({
  selector: 'beh-share-container-dialog',
  imports: [
    CommonModule
  ],
  templateUrl: './share-container-dialog.component.html',
  styleUrl: './share-container-dialog.component.scss'
})
export class ShareContainerDialogComponent extends BaseComponent {
  data = inject<{
    component: Type<any>;
    data: any;
  }>(MAT_DIALOG_DATA);
  private parentInjector = inject(Injector);
  dialogRef = inject<MatDialogRef<ShareContainerDialogComponent>>(MatDialogRef);
  private _bottomSheet = inject(MatBottomSheet);
  private imageDownloaderService = inject(ImageDownloaderService);
  private _localRepository = inject(LocalRepository);


  component: Type<any>;
  componentInjector: Injector;
  @ViewChild('screenshot', { static: false }) screenshot!: ElementRef;


  constructor() {
    super();
    const data = this.data;

    this.component = data.component;
    this.componentInjector = Injector.create({
      providers: [{ provide: MAT_DIALOG_DATA, useValue: this.data.data }],
      parent: this.parentInjector,
    });

  }

  share() {
    const bsh = this._bottomSheet.open(ShareContentDialogComponent, {
      data: null
    });

    bsh.afterDismissed().subscribe(res => {
      if (res == 'download') {
        this.download();
      } else if (res == 'copy') {
        this.copyLink()
      }
    })
  }

  async download() {
    if (!this.screenshot) return;
    const HTMLElement = this.screenshot.nativeElement;

    await this.prepareImg(HTMLElement);

    // wait for full render
    await new Promise(resolve => setTimeout(resolve, 300));

    toPng(HTMLElement, { backgroundColor: "#EEF6F1" })
      .then((imgUrl) => {
        const link = document.createElement('a');
        link.href = imgUrl;
        link.download = 'screenshot.png';
        link.click();
      })
      .catch((err) => {
        console.error('با خطا مواجه شد:', err.message, err);
      });
  }


  async prepareImg(element: HTMLElement) {
    const imgs = Array.from(element.querySelectorAll('img'));

    for (const img of imgs) {
      if (!img.src.startsWith('data:')) {
        try {
          // Convert image URL to Base64
          const response = await this.imageDownloaderService.getBase64ImageFromUrl(img.src);

          // valid Base64 string
          if (typeof response === 'string' && response.startsWith('data:application/json;base64,')) {

            // Remove prefix
            const base64Json = response.replace('data:application/json;base64,', '');

            // JSON string to Base64 content
            const parsedResponse = JSON.parse(atob(base64Json));
            const base64String = parsedResponse.contents;

            img.src = base64String;
          }
        } catch (err) {
          console.error('Error during image conversion:', err);
        }
      }
    }
  }

  copyLink() {
    if (this._localRepository.IsInBrowser) {
      const id = this.data?.data?.id;
      const uniqeName = this.data?.data?.uniqeName;

      let path: string;

      switch (this.data.component) {
        case ShareReviewDialogComponent:
          path = `reviews/${id}`;
          break;
        case ShareQuoteDialogComponent:
          path = `quote/${id}`;
          break;
        case SharePostDialogComponent:
          path = `post/${id}`;
          break;
        case ShareBookListDialogComponent:
          path = `booklist/${id}`;
          break;
        case ShareBookDialogComponent:
          path = `books/${id}`;
          break;
        case ShareProfileDialogComponent:
          path = `profile/${uniqeName ?? id}`;

          if (this.data?.data?.userIsPublisher) {
            path += `?isPublisher=true`;
          }
          break;
        case ShareDonationDialogComponent:
          path = `donate/pre`;
          break;
        default:
          path = '';
      }
      const shareUrl = `${environment.SiteUrl}/${path}`
      navigator.clipboard.writeText(shareUrl).then(() => {
        this.snackbarService.openSnackbar(SnackBarTypes.success, 'لینک با موفقیت کپی شد.');
      }).catch(() => {
        this.snackbarService.openSnackbar(SnackBarTypes.error, 'کپی لینک با خطا مواجه شد.');
      });
    }
  }
}
